module.exports = __webpack_public_path__ + "static/media/TP_Icon_EyeMask2.05bb9427.png";